import { format } from "date-fns";

import { DATE_FORMAT } from "@constants/format";

export const formatDateToLocal = (
  dateString: string,
  formatPattern: string = DATE_FORMAT
): string => {
  const hasTimezoneIndicator = dateString.endsWith('Z') ||
                              dateString.includes('+') ||
                              (dateString.includes('-') && dateString.indexOf('T') < dateString.lastIndexOf('-'));

  const utcDateString = hasTimezoneIndicator ? dateString : `${dateString}Z`;
  const date = new Date(utcDateString);
  
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }
  
  return format(date, formatPattern);
};

export const formatNullableDateToLocal = (
  dateString: string | null | undefined,
  formatPattern: string = DATE_FORMAT,
  fallback = "N/A"
): string => {
  if (!dateString) {
    return fallback;
  }
  
  return formatDateToLocal(dateString, formatPattern);
};
